import { Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FullscreenStatus } from "@/components/layout/FullscreenStatus";
import { getPublicRouteDecision, useAuthStore } from "@/stores/authStore";

export function PublicOnlyRoute() {
  const { t } = useTranslation();
  const authStatus = useAuthStore((state) => state.authStatus);
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const user = useAuthStore((state) => state.user);

  const decision = getPublicRouteDecision({ authStatus, isHydrated });

  if (decision === "pending") {
    return <FullscreenStatus title={t("common.loading")} />;
  }

  if (decision === "verify") {
    return <Navigate to="/verify-email-pending" replace state={{ email: user?.email }} />;
  }

  if (decision === "app") {
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
